/**
 * El aviso de cookies.
 *
 * Va abajo y no tapa la pantalla: quien entro a reservar un turno tiene que
 * poder seguir reservando sin cerrar nada primero. Dice exactamente que se
 * guarda — son tres cosas y se pueden nombrar — y enlaza a la politica de
 * privacidad para el detalle.
 */

import { Cookie, X } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Button } from "./ui";
import { useAvisoPendiente } from "../lib/cookies";

export function AvisoCookies(): ReactNode {
  const { pendiente, cerrar } = useAvisoPendiente();

  if (!pendiente) return null;

  return (
    <div
      // `region` con nombre y no `dialog`: no atrapa el foco ni bloquea la
      // pagina, porque no hay ninguna decision que tomar antes de seguir.
      role="region"
      aria-label="Aviso sobre cookies"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[var(--border-subtle)] bg-[var(--surface-raised)] p-4 shadow-[0_-4px_24px_-12px_rgb(0_0_0/0.25)]"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center">
        <Cookie className="hidden size-5 shrink-0 text-muted sm:block" aria-hidden="true" />

        <p className="flex-1 text-sm leading-relaxed text-muted">
          Usamos solo lo necesario para que esto funcione: la cookie que mantiene tu sesión
          iniciada y, en tu navegador, el tema que elegiste. No hay analítica, publicidad ni
          rastreo de terceros.{" "}
          <Link to="/privacidad" className="text-brand-600 hover:underline">
            Más detalle
          </Link>
          .
        </p>

        <div className="flex shrink-0 items-center gap-2">
          <Button size="sm" onClick={cerrar}>
            Entendido
          </Button>
          <button
            type="button"
            onClick={cerrar}
            aria-label="Cerrar el aviso"
            className="rounded-lg p-1.5 text-muted transition hover:bg-[var(--surface-muted)] sm:hidden"
          >
            <X className="size-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
